import moment from "moment";
import { HandlersCollection, RefDate, RefNumber } from "@tblabs/truffle";


export class DatesRange
{
    public readonly Start: RefDate;
    public readonly End: RefDate;
    public DaysCount = new RefNumber()
    private onChange = new HandlersCollection<(start: Date, end: Date, days: number) => void>();

    constructor(start: string | Date | RefDate = new RefDate(), end: string | Date | RefDate = new RefDate(), private now = new Date())
    {
        if (start instanceof Date)
            this.Start = new RefDate(start);
        else if (typeof start === "string")
            this.Start = new RefDate(new Date(start))
        else
            this.Start = start;

        if (end instanceof Date)
            this.End = new RefDate(end);
        else if (typeof end === "string")
            this.End = new RefDate(new Date(end))
        else
            this.End = end;

        this.Start.value = moment(this.Start.value).hour(12).minute(0).seconds(0).millisecond(0).toDate();
        this.End.value = moment(this.End.value).hour(12).minute(0).seconds(0).millisecond(0).toDate();

        if (this.Start.value < now)
            this.Start.value = now;

        if (this.End.value < now)
            this.End.value = now;

        this.Start.OnChange(start =>
        {
            if (start < now)
            {
                start = now;
                this.Start.value = start;
            }

            this.DaysCount.value = moment(this.End.value).diff(start, 'days') + 1;
           
            const s = moment(this.Start.value);
            const e = moment(this.End.value);

            if (s.isAfter(e))
                this.End.value = this.Start.value;

            this.onChange.Call(start, this.End.value, this.DaysCount.value);
        })

        this.End.OnChange(end =>
        {
            if (end < now)
                end = now;

            this.DaysCount.value = moment(end).diff(this.Start.value, 'days') + 1;

            const s = moment(this.Start.value);
            const e = moment(this.End.value);

            if (s.isAfter(e))
                this.Start.value = this.End.value;

            this.onChange.Call(this.Start.value, end, this.DaysCount.value);
        }, true)
    }

    public AddDay()
    {
        this.End.value = moment(this.End.value).add(1, 'day').toDate();
    }

    public SubtractDay()
    {
        this.End.value = moment(this.End.value).subtract(1, 'day').toDate();

        if (this.End.value < this.now)
            this.End.value = this.now;
    }

    public OnChange(handler: (start: Date, end: Date, days: number) => void)
    {
        this.onChange.Add(handler);
    }
}
